var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.615 53.385C14.315 51.085 15.84 46.2525 14.67 43.4225C13.455 40.5 9 38.125 9 35C9 31.875 13.455 29.5 14.67 26.5775C15.84 23.75 14.315 18.915 16.615 16.615C18.915 14.315 23.75 15.84 26.5775 14.67C29.5125 13.455 31.875 9 35 9C38.125 9 40.5 13.455 43.4225 14.67C46.2525 15.84 51.085 14.315 53.385 16.615C55.685 18.915 54.16 23.7475 55.33 26.5775C56.545 29.5125 61 31.875 61 35C61 38.125 56.545 40.5 55.33 43.4225C54.16 46.2525 55.685 51.085 53.385 53.385C51.085 55.685 46.2525 54.16 43.4225 55.33C40.5 56.545 38.125 61 35 61C31.875 61 29.5 56.545 26.5775 55.33C23.75 54.16 18.915 55.685 16.615 53.385Z",
    stroke: "#326164",
    fill: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31C29.2091 31 31 29.2091 31 27C31 24.7909 29.2091 23 27 23C24.7909 23 23 24.7909 23 27C23 29.2091 24.7909 31 27 31Z",
    stroke: "#326164",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47C45.2091 47 47 45.2091 47 43C47 40.7909 45.2091 39 43 39C40.7909 39 39 40.7909 39 43C39 45.2091 40.7909 47 43 47Z",
    stroke: "#326164",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45L45 25",
    stroke: "#326164",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/Discount.a8ed766b2d0cd8cb3dfa7883a9a5a88f.svg";
export { ForwardRef as ReactComponent };